var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 515,
    viewBox: "0 0 539 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.849 418.125C91.3286 450.988 1.07299 515 1.07299 515L-80 -85L412.674 -74.5833C412.674 -74.5833 615.357 187.917 507.26 345.208C418.227 474.759 300.733 373.247 179.849 418.125Z",
    fill: "#EAF3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground1);
export default __webpack_public_path__ + "static/media/Background1.9e0ec10c561606405ad278c8f36c05a1.svg";
export { ForwardRef as ReactComponent };